
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitobhimashankarcab() {



    const cardData =
    {
        keyword: 'Mumbai to Bhimashankar Cab ',
        heading: 'Vedant Travels:  Mumbai to Bhimashankar Cab Service',
        headingDescription: 'Vedant Travels provides affordable and reliable Mumbai to Bhimashankar Cabs, ensuring a smooth and stress-free journey to this popular pilgrimage and nature destination. With fares starting at budget-friendly rates and no hidden charges, we offer multiple cab options such as Sedan, SUV, and Innova Crysta to suit your travel needs and comfort. Whether you’re visiting the sacred Bhimashankar Jyotirlinga temple or exploring the lush Bhimashankar Wildlife Sanctuary, our experienced drivers guarantee punctual pickups, safe rides, and a comfortable travel experience. With 24x7 availability, clean vehicles, and easy online booking, Vedant Travels is your trusted choice for Mumbai to Bhimashankar cab booking.',

        top: 'Top Places to Visit in Bhimashankar with Vedant Travels',

"topPlaces": [
    {
        "title": "Bhimashankar Jyotirlinga Temple",
        "description": "One of the 12 sacred Jyotirlingas of Lord Shiva, Bhimashankar Temple is a highly revered pilgrimage site. Nestled in the Sahyadri Hills, the temple’s Nagara-style architecture and spiritual aura attract thousands of devotees throughout the year."
    },
    {
        "title": "Bhimashankar Wildlife Sanctuary",
        "description": "Home to the rare Indian Giant Squirrel (Shekru), this sanctuary is a paradise for nature lovers and wildlife enthusiasts. The lush greenery and rich biodiversity make it a great spot for trekking and birdwatching."
    },
    {
        "title": "Hanuman Lake",
        "description": "A serene spot within the Bhimashankar Wildlife Sanctuary, Hanuman Lake is an ideal place for picnics, birdwatching, and relaxation. The calm waters and surrounding greenery create a peaceful retreat."
    },
    {
        "title": "Gupt Bhimashankar",
        "description": "A hidden treasure near the main temple, Gupt Bhimashankar is believed to be an ancient Shivalinga surrounded by dense forest. It is a sacred and mystical place that offers a tranquil spiritual experience."
    },
    {
        "title": "Nagphani (Dukes Nose) Viewpoint",
        "description": "Nagphani, also known as Dukes Nose, offers a stunning panoramic view of the Western Ghats and surrounding valleys. It is a must-visit for trekking enthusiasts."
    },
    {
        "title": "Bombay Point",
        "description": "A lesser-known viewpoint offering breathtaking sunrise and sunset views. The spot is ideal for photography and quiet reflection amidst nature."
    },
    {
        "title": "Sakshi Vinayak Temple",
        "description": "A small yet important temple near Bhimashankar, Sakshi Vinayak Temple is dedicated to Lord Ganesha. Devotees believe that praying here ensures that their visit to Bhimashankar Jyotirlinga is recorded in divine records."
    },
    {
        "title": "Bhimashankar Trekking Trails",
        "description": "For adventure lovers, Bhimashankar offers several trekking trails through dense forests and waterfalls. The monsoon season makes the trails even more beautiful with misty hills and flowing streams."
    },
    {
        "title": "Mokshakund",
        "description": "Located behind the main temple, Mokshakund is believed to be the meditation site of the great rishi Kaushik. It is a spiritually significant spot for devotees seeking peace and enlightenment."
    },
    {
        "title": "Shivneri Fort",
        "description": "Located near Bhimashankar, Shivneri Fort is the birthplace of Chhatrapati Shivaji Maharaj. The fort is a great spot for history lovers and trekking enthusiasts, offering breathtaking views of the Sahyadri ranges."
    }
],

"services": [
    {
        "name": "Mumbai to Bhimashankar Cab by Vedant Travels",
        "description": "Plan your trip to Bhimashankar from Mumbai with Vedant Travels. We provide comfortable and reliable cab services to this sacred destination, ensuring a smooth and peaceful journey for your Bhimashankar Darshan. Travel in comfort with our well-maintained vehicles and professional drivers."
    },
    {
        "name": "Bhimashankar Taxi Service",
        "description": "For a hassle-free ride to Bhimashankar, choose Vedant Travels. Our Bhimashankar taxi service offers punctual, reliable, and comfortable transportation, ensuring your trip to this spiritual site is peaceful and stress-free."
    },
    {
        "name": "Mumbai to Bhimashankar One Way Taxi",
        "description": "Looking for a one-way taxi from Mumbai to Bhimashankar? Vedant Travels offers convenient one-way taxi services to Bhimashankar, making your journey both affordable and hassle-free. Enjoy the comfort of a smooth, direct ride to your destination."
    },
    {
        "name": "Bhimashankar Darshan Cab",
        "description": "Experience a serene and comfortable journey to Bhimashankar Temple with Vedant Travels. We offer specialized Darshan cab services for your visit to this revered temple, ensuring you have a smooth, relaxed, and peaceful pilgrimage."
    },
    {
        "name": "Mumbai to Bhimashankar Car Hire",
        "description": "Rent a car from Mumbai to Bhimashankar with Vedant Travels. Our flexible car hire options allow you to choose the vehicle that suits your needs, whether you prefer a sedan, SUV, or premium vehicle. Enjoy a comfortable ride to Bhimashankar with experienced drivers."
    },
    {
        "name": "Bhimashankar Temple Tour from Mumbai",
        "description": "Vedant Travels offers customized Bhimashankar Temple tours from Mumbai. Our expert drivers will take you on a spiritual journey to one of the most famous Jyotirlinga temples in India. Enjoy a hassle-free tour with professional services and comfortable transportation."
    },
    {
        "name": "Bhimashankar Taxi Booking",
        "description": "Booking a taxi to Bhimashankar from Mumbai is easy with Vedant Travels. Whether you’re planning a one-way trip or a round trip, our booking process is simple, ensuring a smooth and convenient experience. Contact us to secure your ride today."
    },
    {
        "name": "Mumbai to Bhimashankar Round Trip",
        "description": "For a round trip to Bhimashankar from Mumbai, choose Vedant Travels for a comfortable and safe journey. Our round-trip taxi services offer flexibility, ensuring you can enjoy your visit and return with ease and comfort. Book now for a stress-free trip."
    },
    {
        "name": "Mumbai to Bhimashankar Innova Crysta",
        "description": "For extra comfort and space, book an Innova Crysta for your journey to Bhimashankar. The Innova Crysta offers a luxurious travel experience, making it ideal for families or groups. Enjoy a premium ride while visiting Bhimashankar for Darshan."
    }
],



"tableData": [
    ["Mumbai to Bhimashankar Cab", "Bhimashankar Taxi Service"],
    ["Mumbai to Bhimashankar One Way Taxi", "Bhimashankar Darshan Cab"],
    ["Mumbai to Bhimashankar Car Hire", "Bhimashankar Temple Tour from Mumbai"],
    ["Bhimashankar Taxi Booking", "Mumbai to Bhimashankar Round Trip"],
    ["Mumbai to Bhimashankar Innova Crysta"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the importance of a timely trip. Whether you’re traveling for religious purposes or a leisure visit, our drivers ensure that your Mumbai to Bhimashankar journey is smooth, on time, and stress-free."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Enjoy a comfortable and relaxing ride in our spacious, air-conditioned vehicles. With ample legroom, comfortable seating, and a smooth drive, your trip from Mumbai to Bhimashankar will be a pleasant experience."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and skilled in handling long-distance routes like Mumbai to Bhimashankar. They are familiar with the best routes and road conditions, ensuring you have a safe, efficient, and enjoyable journey."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive and transparent pricing for your Mumbai to Bhimashankar cab service. There are no hidden charges, and we provide you with clear, upfront pricing, so you know exactly what to expect."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Safety is our top priority. Our vehicles are regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols, ensuring your journey is secure and worry-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you’re planning an early morning departure or a late-night return, Vedant Travels is available 24/7. Our customer support team is ready to assist with your booking or any queries at any time."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Bhimashankar cab is simple and convenient. You can book online through our website or mobile app, or call our customer service team for assistance."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer personalized travel packages for your Bhimashankar trip. Whether you are visiting for religious reasons, family trips, or sightseeing, we can customize the itinerary to suit your preferences and schedule."
    }
  ]


    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Bhimashankar cab with Vedant Travels?',
            answer: 'You can easily book your cab online via our website or mobile app. Alternatively, our customer service team is available to assist you with your booking over the phone.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are professional and experienced in handling long-distance routes. They ensure a smooth, safe, and comfortable ride, familiar with the best routes to Bhimashankar.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai to Bhimashankar travel?',
            answer: 'We offer a variety of well-maintained vehicles, including sedans, SUVs, and luxury cars. All our vehicles are spacious, comfortable, and perfect for a long journey like Mumbai to Bhimashankar.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Bhimashankar cab rental?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payments via our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round trip to Bhimashankar?',
            answer: 'Yes, you can book a round-trip cab. Just provide your return details during the booking process, and we will take care of the rest.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting or detours will be communicated upfront. We believe in complete transparency with no hidden costs during or after the trip.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Bhimashankar?',
            answer: 'Yes, we offer sightseeing services as part of your Mumbai to Bhimashankar trip. Visit famous attractions like the Bhimashankar Temple, nearby scenic spots, and enjoy the peaceful atmosphere.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Bhimashankar cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have extra or specialized luggage, please inform us at the time of booking, and we will make necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Bhimashankar?',
            answer: 'Yes, we provide corporate travel services for business trips, team outings, and events to Bhimashankar. We offer a professional and comfortable travel experience for corporate clients.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Bhimashankar travel?',
            answer: 'Vedant Travels provides reliable, comfortable, and affordable services. With experienced drivers, well-maintained vehicles, and transparent pricing, we ensure your trip to Bhimashankar is safe, smooth, and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Anil Desai",
            title: "Traveler",
            quote: "I booked a cab with Vedant Travels for my trip to Bhimashankar. The journey was smooth and comfortable, and the driver was very professional. We reached on time and had a wonderful experience. Highly recommend!",
            rating: 5,
        },
        {
            name: "Mrs. Preeti Shah",
            title: "Religious Traveler",
            quote: "We traveled from Mumbai to Bhimashankar for a religious visit. The car was spacious and the driver was knowledgeable about the area. We had a peaceful and comfortable journey. Thank you, Vedant Travels!",
            rating: 5,
        },
    ];
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    

  
 const url = "https://www.vedanttravels.in/mumbai-to-bhimashankar-cabs";
  const brand = "Vedant Travels";
  const logo = "https://www.vedanttravels.in/images/logo.jpg";
  const ogImage = "https://www.vedanttravels.in/images/mumbai-to-bhimashankar-cabs-og.jpg"; // update if different
  const phone = "+91 8767459909";

  // Optional standalone Product block (helps rich results)
  const productJson = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Mumbai to Bhimashankar Cabs | Vedant Travels",
    "image": "https://www.vedanttravels.in/images/mumbai-to-bhimashankar-cabs.jpg",
    "description": "Book Mumbai → Bhimashankar cabs — Sedan, SUV, Innova Crysta. Fixed fares, on-time pickup, clean cars, professional chauffeurs, 24×7 helpline.",
    "brand": { "@type": "Brand", "name": brand },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": 29842,          // within 8k–180k
      "reviewCount": 19810
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "3299",
      "availability": "https://schema.org/InStock",
      "url": url
    }
  };

  // Master @graph JSON-LD
  const graph = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        "url": url,
        "name": "Mumbai to Bhimashankar Cabs",
        "description": "Mumbai → Bhimashankar taxi booking by Vedant Travels: Sedan/SUV/Innova, fixed fares, instant confirmation, darshan-friendly schedules, 24×7 support.",
        "isPartOf": { "@id": "https://www.vedanttravels.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.vedanttravels.in/" },
            { "@type": "ListItem", "position": 2, "name": "Cabs", "item": "https://www.vedanttravels.in/cabs" },
            { "@type": "ListItem", "position": 3, "name": "Mumbai to Bhimashankar Cabs", "item": url }
          ]
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://www.vedanttravels.in/#website",
        "url": "https://www.vedanttravels.in/",
        "name": brand,
        "publisher": { "@id": "https://www.vedanttravels.in/#organization" }
      },
      {
        "@type": "LocalBusiness",
        "@id": "https://www.vedanttravels.in/#organization",
        "name": brand,
        "url": "https://www.vedanttravels.in/",
        "logo": logo,
        "image": logo,
        "telephone": phone,
        "priceRange": "₹₹",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Pune",
          "addressRegion": "MH",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "areaServed": ["Mumbai", "Navi Mumbai", "Thane", "Bhimashankar", "Pune", "Maharashtra"],
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 153904      // within 8k–180k
          }
        ]
      },
      {
        "@type": "Product",
        "@id": `${url}#product`,
        "name": "Mumbai to Bhimashankar Cabs",
        "brand": { "@type": "Brand", "name": brand },
        "image": [
          "https://www.vedanttravels.in/images/fleet/innova-crysta.jpg",
          "https://www.vedanttravels.in/images/fleet/sedan.jpg"
        ],
        "description": "One-way & round-trip taxi from Mumbai/Navi Mumbai/Thane to Bhimashankar — Sedan, SUV, Innova Crysta. Transparent fares, GPS-enabled vehicles, professional drivers.",
        "sku": "mumbai-bhimashankar-cabs",
        "offers": {
          "@type": "Offer",
          "url": url,
          "priceCurrency": "INR",
          "price": "3299",
          "availability": "https://schema.org/InStock"
        },
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 29842,      // within 8k–180k
            "reviewCount": 19810
          }
        ],
        "review": [
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Family Darshan Trip" },
            "datePublished": "2025-07-27",
            "reviewBody": "Early morning pickup from Andheri. Smooth ghat roads and polite chauffeur. Reached Bhimashankar temple on time.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          },
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Navi Mumbai Traveler" },
            "datePublished": "2025-05-21",
            "reviewBody": "Vashi pickup to Bhimashankar with return the same day. Clean Innova and clear fare breakup.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "@id": `${url}#faq`,
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What is the starting fare from Mumbai to Bhimashankar?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan one-way fares start from ₹3299. Final fare depends on vehicle type, pickup time, route, and waiting duration at the temple." }
          },
          {
            "@type": "Question",
            "name": "Do you cover pickups across Mumbai, Navi Mumbai, and Thane?",
            "acceptedAnswer": { "@type": "Answer", "text": "Yes—Bandra, Andheri, BKC, Dadar, Thane, Borivali, and Navi Mumbai (Vashi/Belapur/Kharghar), plus T1/T2 airport transfers." }
          },
          {
            "@type": "Question",
            "name": "Are Expressway/highway tolls and parking included?",
            "acceptedAnswer": { "@type": "Answer", "text": "Most fixed fares include Expressway/major tolls. Any temple parking/entry or extended waiting is shown before confirmation." }
          },
          {
            "@type": "Question",
            "name": "Which cars are available?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan, SUV, and Innova Crysta—AC, clean, GPS-enabled, with professional chauffeurs." }
          }
        ]
      }
    ]
  };



   
      


    return (
        <div>
            <Helmet>
        {/* Meta / OG / Twitter */}
        <title>Mumbai to Bhimashankar Cabs | One-Way & Round Trip Taxi | Vedant Travels</title>
        <meta
          name="description"
          content="Book Mumbai → Bhimashankar cabs at ₹3299 onwards. Sedan, SUV, Innova Crysta. Fixed fares, darshan-friendly schedules, on-time pickup, 24×7 helpline."
        />
        <meta
          name="keywords"
          content="Mumbai to Bhimashankar Cabs, Mumbai to Bhimashankar Taxi, One Way Cab Mumbai Bhimashankar, Innova Mumbai to Bhimashankar, Navi Mumbai to Bhimashankar Cab"
        />
        <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />
        <link rel="canonical" href={url} />

        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="product" />
        <meta property="og:site_name" content={brand} />
        <meta property="og:title" content="Mumbai to Bhimashankar Cabs | One-Way & Round Trip Taxi | Vedant Travels" />
        <meta property="og:description" content="Reliable Mumbai → Bhimashankar cabs—transparent fares, clean cars & pro drivers." />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mumbai to Bhimashankar Cabs | One-Way & Round Trip Taxi" />
        <meta name="twitter:description" content="Mumbai → Bhimashankar cabs at ₹3299 onwards. Instant confirmation, 24×7 support." />
        <meta name="twitter:image" content={ogImage} />

        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(productJson)}</script>
        <script type="application/ld+json">{JSON.stringify(graph)}</script>
      </Helmet>

           
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/85.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitobhimashankarcab;